<div class="header-bar">
  <h1>Mobile Logging</h1>
</div>
<div class="">
  <div class="content-container">
    <div class="card card-w-title">
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-g-12">
          <div class="ui-g-4 ui-sm-12">
            <label for="users">Force logging in mobile application for users</label>
          </div>
          <div class="ui-g-4 ui-sm-12">
            <p-multiSelect [options]="users" [(ngModel)]="userIds"></p-multiSelect>
          </div>
        </div>
      </div>
      <div>
        <button
          type="button"
          pButton
          icon="fa ui-icon-check"
          label="Save"
          (click)="update()"
          class="ui-button green-btn"
        ></button>
      </div>
    </div>
  </div>
</div>
